import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { CoreWindowModule } from '@cigna/shared/angular/core/window-util';
import { CookieService } from 'ngx-cookie-service';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { pdlEnvironment } from '../environments/environment';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';
import {
  gatewaysProviders,
  toSharedGatewaysConfig,
} from '@cigna/pdl-viewer/shared/gateway-util';
import {
  CONFIG,
  manifestAccessorFactory,
  ContentBundleName,
} from '@cigna/pdl-viewer/shared/util';
import {
  CONTENT_BUNDLE_MANIFEST_ACCESSOR,
  contentBundleProviders,
  ResourceContentDataAccessModule,
  ContentResolver,
} from '@cigna/shared/angular/resource-content-data-access';
import { CoreRouterStateModule } from '@cigna/shared/angular/core/router-state-data-access';
import { SharedGatewaysModule } from '@cigna/shared/angular/gateways-util';
import { HttpClientModule } from '@angular/common/http';

import { TranslateModule } from '@ngx-translate/core';
import { SharedTealeafUtilModule } from '@cigna/shared/angular/tealeaf-util';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeaturesModule } from '@cigna/shared/angular/features-feature';
import { AnalyticsDataAccessModule } from '@cigna/shared/angular/analytics-data-access';
import { APP_BASE_HREF } from '@angular/common';

import {
  PdlViewerComponent,
  PdlViewerShellFeatureModule,
} from '@cigna/pdl-viewer/shell-feature';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    PdlViewerShellFeatureModule,
    ResourceContentDataAccessModule,
    TranslateModule.forRoot(),
    RouterModule.forRoot(
      [
        {
          path: '',
          component: PdlViewerComponent,
          resolve: {
            translation: ContentResolver,
          },
          data: {
            preloadContent: [ContentBundleName.GLOBAL, ContentBundleName.LOGO],
          },
        },
      ],
      {
        initialNavigation: 'enabledBlocking',
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'enabled',
      },
    ),
    StoreModule.forRoot(
      {
        router: routerReducer,
      },
      {
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      },
    ),
    CoreRouterStateModule,
    EffectsModule.forRoot([]),
    CoreWindowModule.forRoot(),
    !pdlEnvironment.production
      ? StoreDevtoolsModule.instrument({ connectInZone: true })
      : [],
    StoreRouterConnectingModule.forRoot(),
    SharedGatewaysModule.withConfig(
      toSharedGatewaysConfig(pdlEnvironment.api.gateways),
    ),
    SharedTealeafUtilModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    FeaturesModule,
    AnalyticsDataAccessModule,
  ],
  providers: [
    { provide: CONFIG, useValue: pdlEnvironment },
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    ...contentBundleProviders(pdlEnvironment.contentBundle),
    {
      provide: CONTENT_BUNDLE_MANIFEST_ACCESSOR,
      useFactory: manifestAccessorFactory,
    },
    ...gatewaysProviders(pdlEnvironment.api.gateways),
    CookieService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
